var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlarmMinorEcho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_alarm_minor_echo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alarm_minor_echo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    stroke: "#F3B721",
    cx: 9,
    cy: 9,
    r: 8.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,9 C3,12.314 5.686,15 9,15 C12.314,15 15,12.314 15,9 C15,5.686 12.314,3 9,3 C5.686,3 3,5.686 3,9 Z",
    id: "Clip-2",
    fill: "#F3B721",
    fillRule: "nonzero",
    transform: "translate(9.000000, 9.000000) rotate(-180.000000) translate(-9.000000, -9.000000) "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M6.826,9.272 L12.81,9.272 C12.832,9.206 12.843,9.129 12.843,8.986 C12.843,6.874 11.435,5.741 9.268,5.741 C6.947,5.741 5.561,6.995 5.561,8.997 C5.561,10.977 6.947,12.231 9.356,12.231 C10.764,12.231 11.809,11.89 12.634,11.153 L11.886,10.35 C11.226,10.933 10.533,11.219 9.422,11.219 C7.904,11.219 6.947,10.581 6.826,9.272 Z M9.279,6.753 C10.467,6.753 11.325,7.248 11.6,8.348 L6.881,8.359 C7.123,7.292 8.014,6.753 9.279,6.753 Z",
    id: "e",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmMinorEcho);
export default __webpack_public_path__ + "static/media/icon_alarm_minor_echo.8ce8ccb4f02b869739535e12e41d2ced.svg";
export { ForwardRef as ReactComponent };